import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconChevronDown: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 28 28" fill="none">
    <path
      d="M14 21.4947L6.98834 14.483L8.63801 12.8322L14.0047 18.1988L19.3713 12.8322L21.0117 14.483L14.0012 21.4947H14ZM14 15.1667L6.98834 8.15382L8.63801 6.50415L14.0047 11.8708L19.3713 6.50415L21.0117 8.15382L14.0012 15.1655L14 15.1667Z"
      fill="currentColor"
    />
  </Svg>
)
